import { LoggingService, UserVisibleMessage } from "../sdServices/loggingSvc";
import { FlightingServiceImplementation } from "../sdServices/flightingSvc";
import { JarvisServiceImplementation } from "../sdServices/jarvisSvc";
import { LocalizationService } from "../../ShellCommon/localization/localization";
import { LaunchFromASDKey } from "./serviceDeskConfig";
import { AuthorizationService } from "../sdServices/authorization/authorization";
import { AgentProfileEntityServiceImplementation } from "../sdServices/entity-service-implementation/agent-profile-entity-service";

export class StartupNotification {
  // @ngInject
  constructor(
    private flightingService: FlightingServiceImplementation,
    private jarvisService: JarvisServiceImplementation,
    private sdLocalizationService: LocalizationService,
    private $rootScope: ng.IRootScopeService,
    private loggingService: LoggingService,
    private $window: ng.IWindowService,
    private $state: angular.ui.IStateService,
    private agentProfileEntityService: AgentProfileEntityServiceImplementation,
    private authorizationService: AuthorizationService,
    private $q: ng.IQService
  ) {
    let unregisterCallback = $rootScope.$on("$stateChangeSuccess", () => {
      if (this.$state.current.name !== "preferences") {
        this.logWarningMessageForNonEdgeUsers();
      }
      unregisterCallback();
    });
  }

  public logWarningMessageForNoRolesetUsers() {
    let allPromises = [this.authorizationService.whenReady(), this.agentProfileEntityService.whenReady()];
    this.$q.all(allPromises).then(() => {
      if (!this.authorizationService.hasAnyRight() || !this.agentProfileEntityService.getAgentProfileSync()) {
        if (this.$state.current.name != "sdSystem.unauthorized") {
          this.$state.go("sdSystem.unauthorized");
        }
        let message = this.sdLocalizationService.getLocalizedString("ServiceDesk", "_USER_WITHOUT_ROLESET_WARNING_");
        this.logWarning(message, "sdUserWithoutRolesetWarning");
      }
    });
  }

  private logWarning(message: string, uid: string) {
    this.loggingService.logWarning(message, <UserVisibleMessage>{
      displayText: message,
      uId: uid
    });
  }

  public logWarningMessageForNonEdgeUsers() {
    if (this.$window.sessionStorage.getItem(LaunchFromASDKey) === "true") {
      return;
    }
    let token: string = this.$window.navigator.userAgent;
    if (!token.includes("Edge")) {
      this.flightingService.whenReady().then(() => {
        if (this.flightingService.isFlightActiveSync("WarnNonEdgeBrowsers")) {
          let message = this.sdLocalizationService.getLocalizedString("ServiceDesk", "_NON_EDGE_USER_NOTIFICATION_");
          this.logWarning(message, "sdBrowserWarning");
        }
      });
    }
  }
}
